<template>
  <div class="material" style="width:100%;heigh:100%;">
    <el-card class="table_searchbar">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工序编码：</span>
            <el-input size="small" style="max-width:180px" v-model="searchForm.procedureCode" maxlength="16" placeholder="工序编码"></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工序名称：</span>
            <el-input size="small" style="max-width:180px" v-model="searchForm.procedureName" maxlength="16" placeholder="工序名称"></el-input>
          </div>
        </el-col>
        <!-- <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工作中心：</span>
            <el-select size="small" ref="focusinput" v-model="searchForm.workCenterCode" placeholder="工作中心" filterable style="display:inline-block;max-width:180px">
              <el-option v-for="item in factoryList" :key="item.factoryId" :label="item.factoryName" :value="item.factoryName"></el-option>
            </el-select>
          </div>
        </el-col> -->
        <el-col :span="5">
          <div class="">
            <span class="title">机组：</span>
            <el-select clearable size="small" ref="focusinput" v-model="searchForm.factoryModelCode" placeholder="机组" filterable style="display:inline-block;max-width:180px">
              <el-option v-for="item in workShopList" :key="item.id" :value="item.name" :label="item.name"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div style="text-align:right">
            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="table-card">
      <div class="table_common_operbar ">
        <el-row>
          <el-button v-if="permission.btn_procedureConfig_addConfig" icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增工序</el-button>
          <!-- <el-upload
            class="import_upload"
            accept=".xls, .xlsx"
            :action="uploadUrl()"
            :before-upload="beforeLoad"
            style="display:inline-block;"
            :on-success="uploadComplete"
            v-if="permission.btn_procedureConfig_importConfig"
          >
            <el-button type="primary" size="small">导入工序</el-button>
          </el-upload>
          <div class="import_upload" style="display: inline-block!important;" v-if="permission.btn_material_downloadTheTemplate">
            <a href="/api/procedureConfig/downTemplate" style="display: inline-block">
              <el-button size="small">模板下载<i class="el-icon-download el-icon--right"></i></el-button>
            </a>
          </div> -->
        </el-row>
      </div>
      <el-table :data="tableData" stripe style="width: 100%;">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="procedureCode" label="工序编码" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="procedureName" label="工序名称" min-width="100" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="workCenter" label="工作中心" min-width="100"></el-table-column> -->
        <el-table-column prop="factoryModelName" label="所在机组" min-width="300" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" fixed="right" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" v-if="permission.btn_procedureConfig_updateConfig" @click="showEditDialog(scope.row)" size="small">编辑</el-button>
            <el-button class="btn-del" type="text" v-if="permission.btn_procedureConfig_deleteConfig" @click="deleteProcedure(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" v-if="tableData.length > 0">
        <div class="total_page">
          <span> 共{{ tableTotalPage }}条 </span>
        </div>
        <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
          <el-pagination
            background
            @size-change="sizeChange"
            layout=" sizes, prev, pager, next, jumper"
            :page-count="tableTotalPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size.sync="pageSize"
            :total="tableTotalPage"
            @current-change="pageChange"
            :current-page.sync="tableCurrentPage"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 新增物料开始 -->
    <el-dialog title="新增工序匹配" @close="cancelAddDialog" :visible.sync="addDialogVisible" :width="span == 5 ? '25%' : '35%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="addForm" style="width:90%;margin-left:10%;" class="add_form">
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title">工序编码：</span>
            <el-form-item class="value" prop="procedureCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-input size="small" v-model.trim="addForm.procedureCode" maxlength="100" placeholder="工序编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title">工序名称：</span>
            <el-form-item class="value" prop="procedureName" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-input size="small" v-model.trim="addForm.procedureName" maxlength="100" placeholder="工序名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title" style="width: 100px;margin-left: -30px;">工作中心编码：</span>
            <el-form-item prop="workCenterCode" class="value" :rules="rules.workCenterCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-select size="small" ref="focusinput" v-model="addForm.workCenterCode" placeholder="工作中心编码" filterable style="display:block;max-width:180px">
                <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title" style="width: 100px;margin-left: -30px;">工作中心名称：</span>
            <el-form-item prop="workCenterCode" class="value" :rules="rules.workCenterCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-select size="small" ref="focusinput" v-model="addForm.workCenterCode" placeholder="工作中心名称" filterable style="display:block;max-width:180px">
                <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryName" :value="item.factoryCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title">所在机组：</span>
            <el-form-item class="value" prop="workCenterCode" :rules="rules.workCenterCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-select size="small" ref="focusinput" v-model="addForm.workCenterCode" placeholder="所在机组" filterable style="display:block;max-width:180px">
                <el-option v-for="item in workShopList" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddDialog">确 定</el-button>
        <el-button @click="cancelAddDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增物料结束 -->

    <!-- 编辑点检点检开始 -->
    <el-dialog title="编辑工序" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span == 5 ? '25%' : '35%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="editForm" style="width:90%;margin-left:10%;" class="add_form">
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title">工序编码：</span>
            <el-form-item class="value" prop="procedureCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-input size="small" v-model.trim="addForm.procedureCode" maxlength="100" placeholder="工序编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title">工序名称：</span>
            <el-form-item class="value" prop="procedureName" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-input size="small" v-model.trim="addForm.procedureName" maxlength="100" placeholder="工序名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title" style="width: 100px;margin-left: -30px;">工作中心编码：</span>
            <el-form-item prop="workCenterCode" class="value" :rules="rules.workCenterCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-select size="small" ref="focusinput" v-model="addForm.workCenterCode" placeholder="工作中心编码" filterable style="display:block;max-width:180px">
                <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title" style="width: 100px;margin-left: -30px;">工作中心名称：</span>
            <el-form-item prop="workCenterCode" class="value" :rules="rules.workCenterCode" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-select size="small" ref="focusinput" v-model="addForm.workCenterCode" placeholder="工作中心名称" filterable style="display:block;max-width:180px">
                <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryName" :value="item.factoryCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20" style="margin-bottom:0px">
          <el-col :span="24">
            <span class="title">所在机组：</span>
            <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
              <el-select size="small" ref="focusinput" v-model="addForm.workCenterCode" placeholder="所在机组" filterable style="display:block;max-width:180px">
                <el-option v-for="item in workShopList" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEditDialog">保 存</el-button>
        <el-button @click="cancelEditDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑点检点检结束 -->

    <!-- 批量导入提示框开始 -->
    <el-dialog title="导入详情" style="z-index:99999999999" :close-on-click-modal="false" :visible.sync="exportDialogVisible" :width="span ? '25%' : '30%'" center>
      <div class="exprot_info" style="text-align: center">
        <el-row :gutter="20">
          <span>总共导入工序条数：</span>
          <span>{{ exportInfo.total }}条</span>
        </el-row>
        <el-row :gutter="20">
          <span>导入工序成功条数：</span>
          <span>{{ exportInfo.success }}条</span>
        </el-row>
        <el-row :gutter="20">
          <span>导入工序失败条数：</span>
          <span>{{ exportInfo.fail }}条</span>
        </el-row>
      </div>
      <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
        <a class="import_upload" v-if="exportInfo.url" :href="exportInfo.url">
          <el-button type="primary">下载失败数据</el-button>
        </a>
        <el-button
          type="primary"
          style="margin-left:10px"
          @click="
            () => {
              this.exportDialogVisible = false;
            }
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量导入提示框结束 -->
  </div>
</template>

<script>
export default {
  name: "ProcedureMapWorkshop",
  data() {
    return {
      fristLoad: false,
      exportDialogVisible: false,
      editDialogVisible: false,
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        procedureName: "",
        workCenterCode: "",
        factoryModelCode: "",
        procedureCode: ""
      },
      workShopList: [],
      searchCopy: {},
      exportInfo: {},
      addForm: {
        procedureName: "",
        workCenterCode: "",
        workCenterName: "",
        procedureCode: ""
      },
      viewForm: {},
      tableData: [],
      pageSize: 10,
      tableCurrentPage: 1,
      tableTotalPage: 2,
      addDialogVisible: false,

      data: {
        token: localStorage.getItem("token")
      },
      rules: {
        procedureName: [{ required: true, message: "请输入工序名称", trigger: "blur" }],
        procedureCode: [{ required: true, message: "请输入工序编码", trigger: "blur" }],
        workCenterCode: [{ required: true, message: "请选择机组", trigger: "blur" }]
      },
      factoryList: [],
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  mounted: function() {
    this.initTable();
    this.loadWorkShopList();
    this.getListFactoryModel();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
  },

  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },

  methods: {
    async getListFactoryModel() {
      let res = await this.$RequestUtil.getAsync({ url: "/api/select/listFactoryModel", params: { needWorkShop: true } });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      res.data.forEach(item => {
        if (item.workShopList) {
          item.workShopTxt = item.workShopList.map(w => w.name).join(", ");
        } else {
          item.workShopTxt = "";
        }
      });
      this.factoryList = res.data;
    },
    loadWorkShopList() {
      this.$RequestUtil.get({
        url: "/api/factoryModel/getWorkShopList",
        // type:'sync',
        params: {},
        success: res => {
          if (res.code == 0) {
            this.workShopList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },
    reload() {
      this.initTable();
      this.getListFactoryModel();
      this.$store.commit("delete_reloadPages", "/TechnologyBOM/ProcedureMapWorkshop");
    },

    sizeChange(ev) {
      this.pageSize = ev;
      this.search();
    },

    deleteProcedure(rowData) {
      this.$confirm("此操作将删除该工序名称, 删除后不可撤销，是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/procedureConfig/deleteConfig",
          type: "sync",
          params: {
            id: rowData.id
          },
          success: res => {
            if (res.code != -1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search(1);
            } else {
              this.$message.error(res.message || res.msg);
            }
          }
        });
      });
    },

    cancelEditDialog() {
      this.editDialogVisible = false;
      this.$refs["editForm"].resetFields();
      this.addForm = {
        procedureName: "",
        workCenterCode: "",
        workCenterName: ""
      };
    },

    cancelAddDialog() {
      this.addDialogVisible = false;
      this.$refs["addForm"].resetFields();
      this.addForm.procedureName = "";
      this.addForm.workCenterCode = "";
      this.addForm.workCenterName = "";
    },

    submitAddDialog() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          this.addForm.workCenterName = (this.workShopList.find(item => item.code == this.addForm.workCenterCode) || {}).name;
          this.$RequestUtil.post({
            url: "/api/procedureConfig/addConfig",
            type: "sync",
            params: {
              formList: [
                {
                  ...this.addForm
                }
              ]
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.initTable();
                this.cancelAddDialog();
              } else {
                this.$message.error(res.message);
              }
            }
          });
        }
      });
    },

    submitEditDialog() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          this.addForm.workCenterName = (this.workShopList.find(item => item.code == this.addForm.code) || {}).name;
          this.$RequestUtil.post({
            url: "/api/procedureConfig/updateConfig",
            type: "sync",
            params: this.addForm,
            success: res => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.initTable();
                this.cancelEditDialog();
              } else {
                this.$message.error(res.message);
              }
            }
          });
        }
      });
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;

      this.searchCopy = {
        procedureName: this.searchForm.procedureName || "",
        workCenterCode: this.searchForm.workCenterCode || "",
        factoryModelCode: this.searchForm.factoryModelCode || "",
        procedureCode: this.searchForm.procedureCode || ""
      };
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.procedureName = "";
      form.workCenterCode = "";
      form.factoryModelCode = "";
      form.procedureCode = "";
      this.searchCopy = {
        procedureName: "",
        workCenterCode: "",
        factoryModelCode: "",
        procedureCode: ""
      };
    },

    search: function() {
      this.searchForm = commonUtils.cloneObj(this.searchCopy);
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            procedureName: "",
            workCenterCode: "",
            factoryModelCode: "",
            procedureCode: ""
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/procedureConfig/listConfig",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: this.pageSize,
          procedureName: temp.procedureName,
          workCenterName: temp.workCenterCode,
          workShopName: temp.factoryModelCode,
          procedureCode: temp.procedureCode
        },
        success: res => {
          if (res.code == 0) {
            res.data.forEach(item => {
              if (item.workShopList) {
                item.workShopTxt = item.workShopList.map(w => w.name).join(", ");
              } else {
                item.workShopTxt = "";
              }
            });
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },

    initTable: function() {
      this.search();
    },

    addWindowShow: function() {
      this.addDialogVisible = true;
      setTimeout(() => {
        this.$refs.focusinput.focus();
      }, 0);
    },

    uploadUrl() {
      return `/api/procedureConfig/importConfig?token=${localStorage.getItem("token")}`;
    },

    beforeLoad(file) {
      let fileSize = file.size / 1024 / 1024;
      fileSize = Math.round(fileSize * 100) / 100;
      if (fileSize >= 5) {
        this.$message({
          type: "error",
          message: `文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`
        });
        return false;
      }
      this.$RequestUtil.loading();
    },

    uploadComplete: function(response, file, fileList) {
      this.$RequestUtil.loading().close();
      if (response != null) {
        if (response.code == 0) {
          this.exportInfo.url = response.data.url;
          this.exportInfo.success = response.data.success;
          this.exportInfo.fail = response.data.fail;
          this.exportInfo.total = Number(response.data.fail) + Number(response.data.success);
          this.exportDialogVisible = true;
          this.initTable();
        } else if (response.code == -1) {
          this.$message({
            type: "error",
            message: response.msg
          });
        } else if (response.code == 10) {
          this.$message({
            type: "error",
            message: "登入过期！"
          });
          this.$router.push({ path: "/Login", name: "Login" });
          return;
        }
      }
    },

    showEditDialog: function(rowData) {
      this.editDialogVisible = true;
      this.addForm.id = rowData.id;
      this.$set(this.addForm, "procedureName", rowData.procedureName);
      this.$set(this.addForm, "procedureCode", rowData.procedureCode);
      this.$set(this.addForm, "workCenterCode", rowData.factoryModelCode);
      this.$set(this.addForm, "workCenterName", rowData.factoryModelName);
    }
  }
};
</script>

<style scoped>
/*.material .el-table{*/
/*    overflow: inherit!important;*/
/*}*/

.qrcode_div {
  text-align: center;
}

.add_form .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}

.add_form .value {
  display: inline-block;
}

.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}

.import_upload {
  display: inline;
}

.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 14px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}

.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}
</style>
<style>
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}

.material .el-form-item--mini.el-form-item,
.material .el-form-item--small.el-form-item {
  margin-top: 7px;
  margin-bottom: 13px;
}

.y_left5 {
  margin-left: 5px;
}

.import_upload > .el-upload-list {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/TechnologyBOM/ProcedureMapWorkshop.vue